import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ContaCaixaConfiguracao } from '../models/conta-caixa-configuracao';
import { AcaoContaMenu } from '../models/acao-conta-menu';

@Component({
  selector: 'app-configuracao-caixa',
  standalone: false,
  templateUrl: './configuracao-caixa.component.html',
  styleUrl: './configuracao-caixa.component.scss'
})
export class ConfiguracaoCaixaComponent {

  @Input() acoesConta: AcaoContaMenu[];
  @Input() title: string = 'Configuração do Caixa';
  @Input() contas: ContaCaixaConfiguracao[] = [];
  @Input() mostrarAdicionarTipo: boolean = true;
  @Input() mostrarSelecaoEmMassa: boolean = false;

  termoBusca: string = '';

  @Output() reloadPage = new EventEmitter<void>();
}
